import { useState, useEffect, useMemo } from "react";
import moment from 'moment';
import 'moment/locale/es';

import ProgramMenuCard from './../CardMenu/CardMenu';
import './Search.scss';

import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';

moment.locale('es');

/**
 * Elegir un plato para un día.
 *
 * El catálogo son 222 platos y el buscador los listaba todos igual, sin decir
 * cuándo salió cada uno ni cuáles ya estaban puestos ese día. Así se repitió
 * una ensalada cuatro veces en un mes sin que nadie lo notara.
 */
const ProgramSearchMenu = ({ menus, dayMenu, setDayMenu, nameCat, yaEstan = [] }) => {

  const [texto, setTexto] = useState('');
  const [lista, setLista] = useState(menus || []);

  /* El filtro usaba el texto ANTERIOR —el estado todavía no se había
     actualizado cuando filtraba—, así que la búsqueda iba siempre una letra
     atrasada: escribías "pollo" y te mostraba lo de "poll". */
  useEffect(() => {
    const q = texto.trim().toLowerCase();
    const base = menus || [];
    setLista(q ? base.filter((m) => (m.name || '').toLowerCase().includes(q)) : base);
  }, [texto, menus]);

  /* Los que ya están en el día, arriba del todo marcados: es la pregunta que
     se hace quien programa —"¿ya lo puse?"— antes que ninguna otra. */
  const ordenada = useMemo(() => {
    const puestos = new Set(yaEstan);
    return [...lista].sort((a, b) => {
      const ap = (a.menuTypes || []).some((mt) => puestos.has(mt.id)) ? 0 : 1;
      const bp = (b.menuTypes || []).some((mt) => puestos.has(mt.id)) ? 0 : 1;
      return ap - bp;
    });
  }, [lista, yaEstan]);

  const n = ordenada.length;

  return (
    <div className="busca">
      <div className="busca__cab">
        <h2>{nameCat}</h2>
        <span className="busca__n">
          {n === 0 ? 'Ningún plato' : n === 1 ? '1 plato' : `${n} platos`}
        </span>
      </div>

      <TextField
        fullWidth
        variant="outlined"
        placeholder="Buscar por nombre…"
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>
          ),
        }}
      />

      <div className="busca__lista">
        {n === 0 ? (
          <p className="busca__nada">No hay platos con ese nombre.</p>
        ) : (
          ordenada.map((item) => (
            <ProgramMenuCard
              key={item.id}
              data={item}
              dayMenu={dayMenu}
              setDayMenu={setDayMenu}
              yaEsta={(item.menuTypes || []).some((mt) => yaEstan.includes(mt.id))}
            />
          ))
        )}
      </div>
    </div>
  )
};

export default ProgramSearchMenu;
